import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-cf0d06b4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "sectionWrap",
  id: "sectionWrap"
};
const _hoisted_2 = {
  class: "itemcell"
};
const _hoisted_3 = {
  class: "itemcell"
};
const _hoisted_4 = {
  class: "itemcell"
};
const _hoisted_5 = {
  class: "itemcell"
};
const _hoisted_6 = {
  class: "itemcell"
};
const _hoisted_7 = {
  class: "itemcell"
};
const _hoisted_8 = {
  class: "itemcell alignTopBottom"
};
const _hoisted_9 = {
  class: "mapWrap"
};
const _hoisted_10 = {
  class: "title textover"
};
const _hoisted_11 = {
  id: "bdcontainer",
  class: "bdcontainer",
  ref: "bdcontainer"
};
const _hoisted_12 = {
  class: "itemcell typeTextArea"
};
const _hoisted_13 = {
  class: "itemcell alignTopBottom"
};
const _hoisted_14 = {
  class: "itemcell descItem"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "labeltitle"
}, "拍照要求", -1));
const _hoisted_16 = ["innerHTML"];
const _hoisted_17 = {
  class: "LoginWrap"
};
const _hoisted_18 = {
  class: "popitem"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-user"
}, null, -1));
const _hoisted_20 = {
  class: "popitem"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-clock"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_loading = _resolveComponent("van-loading");
  const _component_van_uploader = _resolveComponent("van-uploader");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_form = _resolveComponent("van-form");
  const _component_van_picker = _resolveComponent("van-picker");
  const _component_van_popup = _resolveComponent("van-popup");
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_form, {
    ref: "clockInform",
    onSubmit: $options.onSubmit
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_field, {
      modelValue: $data.team,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.team = $event),
      name: "team",
      required: "",
      readonly: "",
      rules: [{
        required: true,
        message: '请选择所属团队'
      }],
      label: "所属团队",
      placeholder: "选择所属团队",
      onClick: _cache[1] || (_cache[1] = $event => $data.showTeam = true),
      "input-align": "right",
      "error-message-align": "right"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_van_field, {
      modelValue: $data.teamtype,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.teamtype = $event),
      name: "teamtype",
      label: "团队类型",
      placeholder: "暂无数据",
      required: "",
      readonly: "",
      "input-align": "right"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_van_field, {
      modelValue: $data.name,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.name = $event),
      name: "name",
      required: "",
      label: "活动名称",
      placeholder: "请输入活动名称",
      rules: [{
        required: true,
        message: '请输入活动名称'
      }],
      "input-align": "right",
      "error-message-align": "right"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_van_field, {
      modelValue: $data.startTime,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.startTime = $event),
      name: "startTime",
      required: "",
      label: "活动开始时间",
      placeholder: "请选择活动开始时间",
      rules: [{
        required: true,
        message: '请选择活动开始时间'
      }],
      readonly: "",
      onClick: _cache[5] || (_cache[5] = $event => $options.showDatePop(0)),
      "input-align": "right",
      "error-message-align": "right"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_van_field, {
      modelValue: $data.endTime,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.endTime = $event),
      name: "endTime",
      required: "",
      label: "活动结束时间",
      placeholder: "请选择活动结束时间",
      rules: [{
        required: true,
        message: '请选择活动开始时间'
      }],
      readonly: "",
      onClick: _cache[7] || (_cache[7] = $event => $options.showDatePop(1)),
      "input-align": "right",
      "error-message-align": "right"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_van_field, {
      modelValue: $data.hours,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.hours = $event),
      name: "hours",
      required: "",
      readonly: "",
      label: "时长(小时)",
      "input-align": "right"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_van_field, {
      modelValue: $data.address,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.address = $event),
      name: "address",
      required: "",
      label: "活动地点"
    }, null, 8, ["modelValue"]), _withDirectives(_createElementVNode("div", {
      class: "cellbtn",
      onClick: _cache[10] || (_cache[10] = (...args) => $options.LoadBdmap && $options.LoadBdmap(...args))
    }, [_createVNode(_component_van_icon, {
      name: "location-o"
    }), _createTextVNode("点击获取定位")], 512), [[_vShow, !$data.showMap]]), _withDirectives(_createElementVNode("div", _hoisted_9, [_withDirectives(_createVNode(_component_van_loading, {
      vertical: ""
    }, {
      default: _withCtx(() => [_createTextVNode("加载中...")]),
      _: 1
    }, 512), [[_vShow, $data.maploading]]), _createVNode(_component_van_icon, {
      name: "clear",
      onClick: $options.hideMap
    }, null, 8, ["onClick"]), _createElementVNode("h2", _hoisted_10, _toDisplayString($data.address), 1), _createElementVNode("div", _hoisted_11, null, 512)], 512), [[_vShow, $data.showMap]])]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_van_field, {
      modelValue: $data.introduce,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.introduce = $event),
      name: "introduce",
      rows: "1",
      autosize: "",
      label: "活动简介",
      type: "textarea",
      placeholder: "请输入活动简介",
      "input-align": "right"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_van_field, {
      name: "uploader",
      required: "",
      label: "活动图片"
    }), _createVNode(_component_van_uploader, {
      "after-read": $options.afterRead,
      modelValue: $data.imagesList,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.imagesList = $event),
      onDelete: $options.imagesDelete,
      multiple: ""
    }, null, 8, ["after-read", "modelValue", "onDelete"])]), _createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("div", {
      class: "desc",
      innerHTML: $data.mapconfig[21] === '' ? '暂无' : $data.mapconfig[21]
    }, null, 8, _hoisted_16)]), _createVNode(_component_van_field, {
      modelValue: $data.latandlon,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.latandlon = $event),
      name: "latandlon",
      style: {
        "display": "none"
      }
    }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
      modelValue: $data.latandlon,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.latandlon = $event),
      name: "latandlon",
      style: {
        "display": "none"
      }
    }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
      modelValue: $data.teamtypeId,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => $data.teamtypeId = $event),
      name: "teamtypeId",
      style: {
        "display": "none"
      }
    }, null, 8, ["modelValue"]), _createVNode(_component_van_button, {
      class: "btnWrap",
      round: "",
      block: "",
      type: "info",
      "native-type": "submit"
    }, {
      default: _withCtx(() => [_createTextVNode("提交")]),
      _: 1
    })]),
    _: 1
  }, 8, ["onSubmit"]), _createVNode(_component_van_popup, {
    show: $data.showTeam,
    "onUpdate:show": _cache[17] || (_cache[17] = $event => $data.showTeam = $event),
    position: "bottom"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_picker, {
      columns: $data.teamcolumns,
      "value-key": "title",
      onConfirm: $options.onConfirm,
      onCancel: _cache[16] || (_cache[16] = $event => $data.showTeam = false)
    }, null, 8, ["columns", "onConfirm"])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $data.showDate,
    "onUpdate:show": _cache[20] || (_cache[20] = $event => $data.showDate = $event),
    position: "bottom"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_datetime_picker, {
      modelValue: $data.currentDate,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $data.currentDate = $event),
      type: "datetime",
      title: $data.dateTitle,
      onConfirm: $options.onConfirmdate,
      onCancel: _cache[19] || (_cache[19] = $event => $data.showDate = false)
    }, null, 8, ["modelValue", "title", "onConfirm"])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    id: "loginPop",
    show: $data.showLogin,
    "onUpdate:show": _cache[26] || (_cache[26] = $event => $data.showLogin = $event),
    teleport: "#app"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_createVNode(_component_van_icon, {
      name: "cross",
      onClick: _cache[21] || (_cache[21] = $event => $data.showLogin = false)
    }), _createVNode(_component_van_form, {
      onSubmit: $options.loginsubmit
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_hoisted_19, _createVNode(_component_van_field, {
        modelValue: $data.mobilePhone,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => $data.mobilePhone = $event),
        name: "mobilePhone",
        placeholder: "请输入手机号",
        required: "",
        rules: [{
          required: true,
          message: '请填写手机号'
        }, {
          pattern: /^1[3456789]\d{9}$/,
          message: '手机号码格式错误!'
        }]
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_20, [_hoisted_21, _createVNode(_component_van_field, {
        modelValue: $data.authCode,
        "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => $data.authCode = $event),
        name: "authCode",
        placeholder: "请输入验证码",
        maxlength: "6",
        required: "",
        rules: [{
          required: true,
          message: '请输入验证码'
        }]
      }, null, 8, ["modelValue"]), _createElementVNode("div", {
        class: _normalizeClass(["codebox", {
          'gary': $data.hasCode
        }]),
        onClick: _cache[24] || (_cache[24] = (...args) => $options.getCode && $options.getCode(...args))
      }, _toDisplayString($data.hasCode ? `已发送(${$data.timeNow}s)` : '获取验证码'), 3)]), _createVNode(_component_van_field, {
        modelValue: $data.museumCode,
        "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => $data.museumCode = $event),
        name: "museumCode",
        style: {
          "display": "none"
        }
      }, null, 8, ["modelValue"]), _createVNode(_component_van_button, {
        class: "submitBtn",
        type: "primary",
        block: "",
        "native-type": "submit"
      }, {
        default: _withCtx(() => [_createTextVNode("登录")]),
        _: 1
      })]),
      _: 1
    }, 8, ["onSubmit"])])]),
    _: 1
  }, 8, ["show"])]);
}